import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import LampBorderZoneDepiction from '../containers/LampBorderZoneDepiction';

const LampBorderZoneWrapper = (props) => {
  return <LampBorderZoneDepiction {...props} />;
};

LampBorderZoneWrapper.propTypes = {
  lamp: PropTypes.object.isRequired,
  lampType: PropTypes.object.isRequired,
};

function mapStateToProps(state, {id}) {
  const {lampReducer, lampTypeReducer} = state;
  const lamp = lampReducer[id];
  const {typeId} = lamp;
  const lampType = lampTypeReducer[typeId];
  return {
    lamp,
    lampType,
  };
}

export default connect(
  mapStateToProps,
  {},
)(LampBorderZoneWrapper);
